import { ToastContainer } from 'react-toastify'
import { MyRoutes } from './routes';
import { ContextWrapper } from './context/ContextWrappter';
import "react-toastify/dist/ReactToastify.css";
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/styles/app.scss'

function App() {

	const { theme } = window['appconfig']

  return (
    <ContextWrapper>
        <div className="App">
		<style>
			{`
				.App::-webkit-scrollbar-thumb {
					background: ${theme.primaryColor};
					border-radius: 20px;
				}

				.App::-webkit-scrollbar-thumb:hover {
					background: ${theme.secondaryColor};
				}

				.user_field .checkmark:after {
					background: ${theme.primaryColor};
				}
			`}
		</style>
            <MyRoutes/>
            <ToastContainer />
        </div>
    </ContextWrapper>
  );
}

export default App;
